import type { IconSvgObject } from './types';

const VoteIcon: IconSvgObject = [
  ["path", { d: "M6 11C6 8.17157 6 6.75736 6.87868 5.87868C7.75736 5 9.17157 5 12 5C14.8284 5 16.2426 5 17.1213 5.87868C18 6.75736 18 8.17157 18 11V19H6V11Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 19H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 11.8096C10.4484 12.0035 11.0045 12.5043 11.2735 12.9082C11.3632 13.4737 11.8117 11.2926 14 10", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default VoteIcon;
